import React from 'react';
import './IndustrialBackground.css';

const IndustrialBackground = () => {
  return (
    <div className="industrial-background">
      {/* Robot Arm 1 - Izquierda */}
      <div className="robot-arm robot-1">
        <svg width="200" height="200" viewBox="0 0 200 200" fill="none">
          <g className="arm-base">
            <circle cx="100" cy="180" r="15" fill="#00FFD1" opacity="0.2" />
            <rect x="95" y="150" width="10" height="30" fill="#00FFD1" opacity="0.3" className="arm-segment-1" />
          </g>
          <g className="arm-middle" style={{ transformOrigin: '100px 150px' }}>
            <rect x="95" y="100" width="10" height="50" fill="#00FFD1" opacity="0.4" className="arm-segment-2" />
            <circle cx="100" cy="100" r="8" fill="#00FFD1" opacity="0.5" />
          </g>
          <g className="arm-end" style={{ transformOrigin: '100px 100px' }}>
            <rect x="95" y="70" width="10" height="30" fill="#00FFD1" opacity="0.5" className="arm-segment-3" />
            <path d="M 95 70 L 85 60 L 95 60 Z" fill="#00FFD1" opacity="0.6" className="gripper-left" />
            <path d="M 105 70 L 115 60 L 105 60 Z" fill="#00FFD1" opacity="0.6" className="gripper-right" />
          </g>
        </svg>
      </div>

      {/* Robot Arm 2 - Derecha */}
      <div className="robot-arm robot-2">
        <svg width="180" height="180" viewBox="0 0 180 180" fill="none">
          <g className="arm-base-2">
            <circle cx="90" cy="160" r="12" fill="#00FFD1" opacity="0.2" />
            <rect x="86" y="135" width="8" height="25" fill="#00FFD1" opacity="0.3" className="arm2-segment-1" />
          </g>
          <g className="arm-middle-2" style={{ transformOrigin: '90px 135px' }}>
            <rect x="86" y="95" width="8" height="40" fill="#00FFD1" opacity="0.4" className="arm2-segment-2" />
            <circle cx="90" cy="95" r="6" fill="#00FFD1" opacity="0.5" />
          </g>
          <g className="arm-end-2" style={{ transformOrigin: '90px 95px' }}>
            <rect x="86" y="70" width="8" height="25" fill="#00FFD1" opacity="0.5" className="arm2-segment-3" />
            <rect x="82" y="65" width="16" height="5" fill="#00FFD1" opacity="0.6" className="gripper-2" />
          </g>
        </svg>
      </div>

      {/* Floating Gears */}
      <div className="gear gear-1">
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
          <circle cx="40" cy="40" r="20" stroke="#00FFD1" strokeWidth="2" opacity="0.2" />
          <circle cx="40" cy="40" r="12" stroke="#00FFD1" strokeWidth="1" opacity="0.3" />
          {[0, 45, 90, 135, 180, 225, 270, 315].map((angle, i) => (
            <rect
              key={i}
              x="38"
              y="18"
              width="4"
              height="8"
              fill="#00FFD1"
              opacity="0.3"
              style={{
                transformOrigin: '40px 40px',
                transform: `rotate(${angle}deg)`
              }}
            />
          ))}
        </svg>
      </div>

      <div className="gear gear-2">
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
          <circle cx="30" cy="30" r="15" stroke="#00FFD1" strokeWidth="1.5" opacity="0.2" />
          <circle cx="30" cy="30" r="9" stroke="#00FFD1" strokeWidth="1" opacity="0.3" />
          {[0, 60, 120, 180, 240, 300].map((angle, i) => (
            <rect
              key={i}
              x="28.5"
              y="14"
              width="3"
              height="6"
              fill="#00FFD1"
              opacity="0.3"
              style={{
                transformOrigin: '30px 30px',
                transform: `rotate(${angle}deg)`
              }}
            />
          ))}
        </svg>
      </div>

      <div className="gear gear-3">
        <svg width="100" height="100" viewBox="0 0 100 100" fill="none">
          <circle cx="50" cy="50" r="25" stroke="#00FFD1" strokeWidth="2" opacity="0.15" />
          <circle cx="50" cy="50" r="15" stroke="#00FFD1" strokeWidth="1" opacity="0.25" />
          {[0, 30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330].map((angle, i) => (
            <rect
              key={i}
              x="48"
              y="22"
              width="4"
              height="8"
              fill="#00FFD1"
              opacity="0.25"
              style={{
                transformOrigin: '50px 50px',
                transform: `rotate(${angle}deg)`
              }}
            />
          ))}
        </svg>
      </div>

      {/* Circuit Lines */}
      <svg className="circuit-lines" width="100%" height="100%" style={{ position: 'absolute', top: 0, left: 0 }}>
        <defs>
          <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#00FFD1" stopOpacity="0" />
            <stop offset="50%" stopColor="#00FFD1" stopOpacity="0.3" />
            <stop offset="100%" stopColor="#00FFD1" stopOpacity="0" />
          </linearGradient>
        </defs>
        
        <path
          d="M 0 20 L 200 20 L 200 80"
          stroke="url(#lineGradient)"
          strokeWidth="1"
          fill="none"
          className="circuit-path-1"
        />
        <circle cx="200" cy="20" r="3" fill="#00FFD1" opacity="0.4" className="circuit-node" />
        
        <path
          d="M 100 0 L 100 150 L 300 150"
          stroke="url(#lineGradient)"
          strokeWidth="1"
          fill="none"
          className="circuit-path-2"
        />
        <circle cx="100" cy="150" r="3" fill="#00FFD1" opacity="0.4" className="circuit-node" />
      </svg>

      {/* Floating Particles */}
      {[...Array(15)].map((_, i) => (
        <div
          key={i}
          className="particle"
          style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 5}s`,
            animationDuration: `${8 + Math.random() * 7}s`
          }}
        />
      ))}

      {/* Data Stream Lines */}
      <div className="data-stream stream-1"></div>
      <div className="data-stream stream-2"></div>
      <div className="data-stream stream-3"></div>

      {/* Grid Pattern */}
      <div className="grid-pattern"></div>
    </div>
  );
};

export default IndustrialBackground;
